import { apiGet, apiDelete, apiMultipart, parseApiError } from "../utils";

export const getLeagues = async (
  page,
  perPage,
  _search = "",
  { sortOrder = "ASC" } = {},
) => {
  const response = await apiGet("/admin/league", { perPage, page, sortOrder });
  if (!response.ok) {
    await parseApiError(response);
  }
  const { items, totalCount } = await response.json();
  return { items, totalCount };
};

export const createLeague = async (payload) => {
  const fd = new FormData();
  fd.append("name", payload.name);
  if (payload.file) {
    fd.append("file", payload.file);
  }

  const response = await apiMultipart("/admin/league", fd, { method: "POST" });
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};

export const updateLeague = async (id, payload) => {
  const fd = new FormData();
  fd.append("name", payload.name);
  if (payload.file) {
    fd.append("file", payload.file);
  } else if (payload.removeIcon) {
    fd.append("removeIcon", "true");
  }

  const response = await apiMultipart(`/admin/league/${id}`, fd, {
    method: "PUT",
  });
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};

export const deleteLeague = async (id) => {
  const response = await apiDelete(`/admin/league/${id}`);
  if (response.status === 204) {
    return {};
  }
  if (!response.ok) {
    await parseApiError(response);
  }
  return await response.json();
};
